export const PAGE_QUESTIONS = "/page/questions/";
export const PAGE_SERVICE = "/page/service/";
export const PAGE_SEGMENTS = "/page/segments/";
